module.exports = __webpack_public_path__ + "static/media/ai.5d9fb424.png";